import React, { useEffect } from "react";
import { Col, Row, Toast, ToastContainer } from "react-bootstrap";
import success from "@frameworks/shared-library/assets/images/salesjourney/SuccessToast.svg";
var SalesToasts = function (props) {
    useEffect(function () {
        return function () {
            props.setShow(false);
        };
    }, []);
    return (React.createElement("div", { className: props.parentClass ? props.parentClass : "" },
        React.createElement(ToastContainer, { className: "parentToaster salestoaster", position: props.position },
            React.createElement(Toast, { className: "d-block ".concat(props.isError ? "dangerbody" : "successbody"), onClose: function () { return props.setShow(false); }, show: props.show, delay: props.delaytime ? props.delaytime : 1000000, autohide: true },
                React.createElement("div", { className: "sales-toast-btn-head" },
                    React.createElement("button", { type: "button", className: "edel-icon-bold-close", onClick: function () { return props.setShow(false); } })),
                React.createElement(Toast.Body, { className: "lead-toaster" }, props.isError ? (React.createElement("div", { className: "DMSansNormal_12_400 txt_blackOne1 taCenter" },
                    React.createElement("span", { className: "toast-danger" },
                        React.createElement("i", { onClick: function () { return props.setShow(false); }, className: "edel-icon-validation" })),
                    React.createElement("span", { className: "mgl-10 txt_bloodRed" }, props.message))) : (
                // <Row className="DMSansNormal_12_400 txt_blackOne1 taCenter align-items-center">
                //   <Col lg={1} className="toast-danger">
                //     <i className="edel-icon-validation"></i>
                //   </Col>
                //   <Col className="mgl-10 txt_bloodRed px-0">{props.message}</Col>
                // </Row>
                React.createElement(Row, { className: "DMSansNormal_12_400 txt_blackOne1  taCenter align-items-center" },
                    React.createElement(Col, { lg: 1, className: "toast-success" },
                        React.createElement("img", { src: success })),
                    React.createElement(Col, { className: "mgl-10 px-0" }, props.message))))))));
};
export default SalesToasts;
